import { IconComponent } from '@alltrails/denali/components/Icon';
import Backpacking from '@alltrails/denali/icons/Backpacking';
import Beach from '@alltrails/denali/icons/Beach';
import BikingMtn from '@alltrails/denali/icons/BikingMtn';
import BikingRoad from '@alltrails/denali/icons/BikingRoad';
import BikingTouring from '@alltrails/denali/icons/BikingTouring';
import BirdWatching from '@alltrails/denali/icons/BirdWatching';
import Block from '@alltrails/denali/icons/Block';
import CalendarStar from '@alltrails/denali/icons/CalenderStar';
import Camping from '@alltrails/denali/icons/Camping';
import Cave from '@alltrails/denali/icons/Cave';
import City from '@alltrails/denali/icons/City';
import Closure from '@alltrails/denali/icons/Closure';
import Fishing from '@alltrails/denali/icons/Fishing';
import Hiking from '@alltrails/denali/icons/Hiking';
import HistoricSite from '@alltrails/denali/icons/HistoricSite';
import Horseback from '@alltrails/denali/icons/Horseback';
import HotSpring from '@alltrails/denali/icons/HotSpring';
import Kayaking from '@alltrails/denali/icons/Kayaking';
import Lake from '@alltrails/denali/icons/Lake';
import OffTrail from '@alltrails/denali/icons/OffTrail';
import Ohv from '@alltrails/denali/icons/Ohv';
import PlacePark from '@alltrails/denali/icons/PlacePark';
import Plant from '@alltrails/denali/icons/Plant';
import Pub from '@alltrails/denali/icons/Pub';
import RailTrail from '@alltrails/denali/icons/RailTrail';
import River from '@alltrails/denali/icons/River';
import RockClimbing from '@alltrails/denali/icons/RockClimbing';
import Running from '@alltrails/denali/icons/Running';
import ScenicDriving from '@alltrails/denali/icons/ScenicDriving';
import Scramble from '@alltrails/denali/icons/Scramble';
import SkiingCrossCountry from '@alltrails/denali/icons/SkiingCrossCountry';
import SkiingDownhill from '@alltrails/denali/icons/SkiingDownhill';
import Snowshoeing from '@alltrails/denali/icons/Snowshoeing';
import Sun from '@alltrails/denali/icons/Sun';
import TrailDog from '@alltrails/denali/icons/TrailDog';
import TrailGravel from '@alltrails/denali/icons/TrailGravel';
import TrailKids from '@alltrails/denali/icons/TrailKids';
import TrailPartiallyPaved from '@alltrails/denali/icons/TrailPartiallyPaved';
import TrailPaved from '@alltrails/denali/icons/TrailPaved';
import TrailStroller from '@alltrails/denali/icons/TrailStroller';
import TrailWheelchair from '@alltrails/denali/icons/TrailWheelchair';
import ViaFerrata from '@alltrails/denali/icons/ViaFerrata';
import Views from '@alltrails/denali/icons/Views';
import Walking from '@alltrails/denali/icons/Walking';
import Wallet from '@alltrails/denali/icons/Wallet';
import Waterfall from '@alltrails/denali/icons/Waterfall';
import Wildflowers from '@alltrails/denali/icons/Wildflowers';
import Wildlife from '@alltrails/denali/icons/Wildlife';
import { TrailActivityType, TrailObstacle } from '@alltrails/trails';
import type TrailFeature from '@alltrails/types/TrailFeature';

type Tag = TrailActivityType | TrailFeature | TrailObstacle;

const icons: Record<Tag, IconComponent> = {
  walking: Walking,
  'via-ferrata': ViaFerrata,
  snowshoeing: Snowshoeing,
  skiing: SkiingDownhill,
  'scenic-driving': ScenicDriving,
  'trail-running': Running,
  'rock-climbing': RockClimbing,
  'road-biking': BikingRoad,
  'paddle-sports': Kayaking,
  'off-road-driving': Ohv,
  'mountain-biking': BikingMtn,
  'horseback-riding': Horseback,
  fishing: Fishing,
  'cross-country-skiing': SkiingCrossCountry,
  camping: Camping,
  birding: BirdWatching,
  'bike-touring': BikingTouring,
  backpacking: Backpacking,
  hiking: Hiking,
  wildlife: Wildlife,
  'wild-flowers': Wildflowers,
  waterfall: Waterfall,
  views: Views,
  river: River,
  'pub-crawl': Pub,
  lake: Lake,
  'hot-springs': HotSpring,
  'historic-site': HistoricSite,
  forest: PlacePark,
  'city-walk': City,
  cave: Cave,
  beach: Beach,
  fee: Wallet,
  scramble: Scramble,
  rocky: TrailGravel,
  'off-trail': OffTrail,
  ada: TrailWheelchair,
  strollers: TrailStroller,
  'private-property': Closure,
  paved: TrailPaved,
  'partially-paved': TrailPartiallyPaved,
  kids: TrailKids,
  'dogs-leash': TrailDog,
  dogs: TrailDog,
  'over-grown': Plant,
  'no-shade': Sun,
  'dogs-no': Block,
  event: CalendarStar,
  'rails-trails': RailTrail
};

export default icons;
